var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('BaseGridLayout',[(_vm.remoteDatasetLoaded)?_c('TeaserServiceOverview',{attrs:{"anchor-name":_vm.anchorName,"headline":_vm.headline,"services":_vm.mappedTeaserServices,"batch-size":_vm.batchSize,"show-load-more-button":_vm.showLoadMoreButton}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }